import React from 'react';
import { IProps } from './types';
import _ from 'lodash';
import { InsureRuleCount } from 'constants/enums/showCount.enum';

const MotoInsureRules: React.FC<IProps> = (props) => {
  /**
   * @description 建立左側標頭 (手機版)
  */
  const handleCreateTitleMobile = () => {
    const titles = new Array(0);
    _.forEach(props.motoLmt, (content:string[], index:number) => {
      if (!content[0] && index < 3) return;

      titles.push(content[0]);
    });

    return _.map(titles, (str:string, index:number) => (
      <div className={str !== '' ? 'element__table-grid-y-title' : 'element__table-grid-y-divider'} key={index}>
        {str}
      </div>
    ));
  };

  /**
   * @description 建立上方顯示標頭
  */
  const handleCreateHeader = () => {
    const motoLmtCpy = [...props.motoLmt];
    const motoLmtVal = motoLmtCpy.splice(0, 3);
    const headerTop:any[] = _.filter(motoLmtVal[0], (str:string) => str);
    const headerMedium:any[] = _.filter(motoLmtVal[1], (str:string) => str);
    const headerBottom:any[] = _.filter(motoLmtVal[2], (str:string) => str);
    return (
      <>
        <tr className="element__table-grid-main-title-tr">
          <th />
          {
            _.map(headerTop, (content:string, index:number) => {
              if (!content) return;

              if (index === 0) return <th key={index} colSpan={4}>{content}</th>;

              if (index === headerTop.length - 1) return <th key={index}>{content}</th>;

              return <th key={index} colSpan={2}>{content}</th>;
            })
          }
        </tr>
        <tr className="element__table-grid-x-title-tr">
          {
            _.map(headerMedium, (content:string, index:number) => {
              if (index === 1 || index === 2) return <th key={index} colSpan={2}>{content}</th>;

              return <th key={index} rowSpan={2}>{content}</th>;
            })
          }
        </tr>
        <tr className="element__table-grid-x-title-tr">
          {
            _.map(headerBottom, (content:string, index:number) => {
              return <th key={index}>{content}</th>;
            })
          }
        </tr>
      </>
    );
  };

  /**
   * @description 建立欄位內容集合
  */
  const handleCreateTbody = (motoLmt:string[][]) => {
    const tbody = new Array(0);

    for (let i = 3; i < motoLmt.length; i += 1) {
      const child = handleCreateBody(motoLmt[i], i);
      tbody.push(child);
    }

    return tbody;
  };

  /**
   * @description 建立欄位內容
  */
  const handleCreateBody = (content:string[], index:number) => {
    if (content.length === 0) return;

    const childs = new Array(0);
    childs.push(<th key={0} className="element__table-grid-y-title">{content[0]}</th>);
    for (let i = 1; i <= InsureRuleCount.Default; i += 1) {
      let child = <td key={i} />;
      if (content[i] && content[i].toUpperCase() === 'V') {
        child = (
          <td key={i}>
            <i className="element__tick-icon" />
          </td>
        );
      }
      childs.push(child);
    }

    const tableTr = content.length > 1 ? (
      <tr key={index}>{childs}</tr>
    ) : (
      <tr key={index} className="element__table-grid-x-divider">{childs}</tr>
    );

    return tableTr;
  };

  return props.motoLmt && props.motoLmt[0] && props.motoLmt[0].length > 0 ? (
    <div className="moto-insure-rules">
      <div className="moto-insure-rules__prod-limit-table">
        <div className="moto-insure-rules__prod-limit-table-title">承保範圍</div>
        <div className="element__table-grid">
          <div className="element__table-grid-y-fixed">
            {handleCreateTitleMobile()}
          </div>
          <div className="element__table-grid-wrap">
            <div className="element__table-grid-container">
              <table>
                <tbody>
                  {handleCreateHeader()}
                  {handleCreateTbody(props.motoLmt)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default MotoInsureRules;
